import { render, staticRenderFns } from "./linea-etica-o-de-denuncia.vue?vue&type=template&id=5976ae77&lang=html&"
import script from "./linea-etica-o-de-denuncia.vue?vue&type=script&lang=js&"
export * from "./linea-etica-o-de-denuncia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports